import Icon1 from "@assets/icons/Icon";
import BaseModal from "@components/modals/BaseModal";
import SecondaryButton from "@components/ui/buttons/SecondaryButton";
import Button from "@components/ui/buttons/Button";
import { useState } from "react";
import TextField from "@components/ui/textfields/TextField";
import AreaTextField from "@components/ui/textfields/AreaTextField";
import DatePicker from "@components/ui/selection/DatePicker";
import { Broadcast } from "types";
import { showNotification } from "context/notification.service";
import { useProjectStore } from "@store/projectStore";
import { useDataStore } from "@store/user_org";
import { getFlutterTime, getFlutterFromSeconds } from "@services/timeHelpers";

export const CreateBroadcastModal = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const addBroadcast = useProjectStore((state) => state.addBroadcast);
  const userData = useDataStore((state) => state.userData);

  const todaySeconds = Math.floor(Date.now() / 1000);
  const inTwoDaysSeconds = todaySeconds + 2 * 24 * 60 * 60;

  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [startDateSeconds, setStartDateSeconds] = useState(todaySeconds);
  const [endDateSeconds, setEndDateSeconds] = useState(inTwoDaysSeconds);

  function handleSave() {
    if (!title.trim()) {
      showNotification({
        type: "error",
        message: "Le titre est obligatoire",
      });
      return;
    }

    const now = getFlutterTime();
    const broadcast: Broadcast = {
      id: `broadcast_${Date.now()}`,
      title: title.trim(),
      content,
      author: {
        id: userData?.id || "unknown",
        display_name: userData?.infos.display_name || "Utilisateur",
        color_tag: userData?.customization.color_tag || "#6B7280",
      },
      org_id: userData?.org_id || "org1",
      start_date: getFlutterFromSeconds(startDateSeconds),
      end_date: getFlutterFromSeconds(endDateSeconds),
      status: "active",
      created_at: now,
      updated_at: now,
    };

    addBroadcast(broadcast, userData?.org_id || "");
    showNotification({
      type: "success",
      message: "Annonce créée avec succès",
    });
    onClose();
  }

  return (
    <BaseModal
      title="Créer une annonce"
      startIcon={<Icon1 name="broadcast" size={20} />}
      onClose={onClose}
    >
      <div className="bg-white flex flex-col gap-2 p-4">
        <div className="flex flex-row gap-2">
          <DatePicker
            label="Date de début (00:01)"
            seconds={startDateSeconds}
            onChange={(seconds) => setStartDateSeconds(seconds)}
          />
          <DatePicker
            label="Date de fin (23:59)"
            seconds={endDateSeconds}
            onChange={(seconds) => setEndDateSeconds(seconds)}
            minDateSeconds={startDateSeconds}
          />
        </div>
        <div className="flex flex-row gap-2">
          <TextField
            label="Titre"
            placeholder="Vacances de Noël"
            mandatory={true}
            value={title}
            onChange={(value) => setTitle(value)}
          />
          <TextField
            label="Auteur"
            value={userData?.infos.display_name || ""}
            disabled={true}
          />
        </div>
        <AreaTextField
          label="Contenu"
          placeholder="Rédigez votre annonce ici..."
          value={content}
          onChange={(value) => setContent(value)}
          rows={8}
        />
      </div>
      <div className="border-t-1 p-4 flex flex-row justify-end gap-2">
        <SecondaryButton variant="small" onClick={onClose}>
          Fermer
        </SecondaryButton>
        <Button
          variant="small"
          label="Programmer"
          onClick={handleSave}
        />
      </div>
    </BaseModal>
  );
};
